import React, { useEffect, useRef } from 'react';
import { connect } from 'react-redux'
import { bindActionCreators } from "redux";
import * as subscriptionAction from '../../actions/subscriptionTeam';

const PaymentCancelFunc = (props) => {

  const getApis = () => {
    props.getPaymentStatus()
  }
  useEffect(() => {
    getApis()
  }, []);

  return (
    <div className='payment_status_container'>
      <img src={require('assets/images/paymentfail.png')} alt='success' />
    </div>
  )
};

const mapStateToProps = ({ subscriptionTeam, loader }) => {
  return {
    subscriptionTeam,
    loader,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(subscriptionAction, dispatch)
};

const PaymentCancel = connect(mapStateToProps, mapDispatchToProps)(PaymentCancelFunc)

export { PaymentCancel }